import { Modal } from "antd";
import { isDouyinMiniProgramEnv } from "./miniProgramEnv";
import "../components/common/H5PromptModal.css";

/** 抖音小程序内是否拦截订阅 / 购买流程 */
export function isDouyinMiniProgramSubscribeBlocked(): boolean {
  return isDouyinMiniProgramEnv();
}

export function promptDouyinMiniProgramSubscribeBlocked(): void {
  const modal = Modal.info({
    className: "lf-h5-prompt-modal",
    icon: null,
    centered: true,
    width: 320,
    closable: true,
    maskClosable: true,
    footer: null,
    content: (
      <>
        <div className="lf-h5-prompt-modal__body lf-h5-prompt-modal__body--left">
          <p className="lf-h5-prompt-modal__title">提示</p>
          <p className="lf-h5-prompt-modal__desc">抖音小程序暂不支持购买，目前支持：</p>
          <p className="lf-h5-prompt-modal__desc">1、电脑端打开 v.longfans.com 购买支付（PC服务体验也更好）</p>
          <p className="lf-h5-prompt-modal__desc">2、微信 搜索 打开 “龙粉社”小程序进行支付。</p>
          <p className="lf-h5-prompt-modal__desc">3、联系消息中的服务专员进行支付。</p>
        </div>
        <div className="lf-h5-prompt-modal__actions lf-h5-prompt-modal__actions--single">
          <button
            type="button"
            className="lf-h5-prompt-modal__btn lf-h5-prompt-modal__btn--primary lf-h5-prompt-modal__btn--block"
            onClick={() => modal.destroy()}
          >
            知道了
          </button>
        </div>
      </>
    ),
  });
}

/** 抖音环境弹提示并中断；否则执行 action */
export function guardDouyinMiniProgramSubscribe(action: () => void): void {
  if (isDouyinMiniProgramSubscribeBlocked()) {
    promptDouyinMiniProgramSubscribeBlocked();
    return;
  }
  action();
}
